export const translations = {
  "Add event to calendar": {
    english: "Add event to calendar",
    spanish: "Agregar evento al calendario",
  },
  "Add to Calendar": {
    english: "Add to Calendar",
    spanish: "Agregar al Calendario",
  },
  close: {
    english: "Close",
    spanish: "Cerrar",
  },
  "opens in new tab": {
    english: "opens in new tab",
    spanish: "abre en una pestaña nueva",
  },
};
